import findLast from 'lodash/findLast';

export default function getDemoPositionMapboxStyle(
    layerTypes: {[key: string]: LayerType},
    layers: Layer[]
): mapboxgl.Style | undefined {
    const demoPositionLayer = findLast(layers, (layer: Layer) => {
        if (!layerTypes[layer.type]) return false;
        return layerTypes[layer.type].center !== null;
    });
    if (!demoPositionLayer) return undefined;

    const demoPositionLayerType = layerTypes[demoPositionLayer.type];
    if (!demoPositionLayerType.center) return undefined;

    return {
        version: 8,
        center: demoPositionLayerType.center,
        zoom: demoPositionLayerType.center[2],
    };
}
